// Safe localStorage utility to handle browser restrictions
const storage = {
  // Check if localStorage is available
  isAvailable() {
    try {
      const test = "__localStorage_test__";
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  },

  // Get item from localStorage
  getItem(key) {
    try {
      if (this.isAvailable()) {
        return localStorage.getItem(key);
      }
      return null;
    } catch (e) {
      console.warn(`Failed to get ${key} from localStorage:`, e);
      return null;
    }
  },

  // Set item in localStorage
  setItem(key, value) {
    try {
      if (this.isAvailable()) {
        localStorage.setItem(key, value);
        return true;
      }
      return false;
    } catch (e) {
      console.warn(`Failed to set ${key} in localStorage:`, e);
      return false;
    }
  },

  // Remove item from localStorage
  removeItem(key) {
    try {
      if (this.isAvailable()) {
        localStorage.removeItem(key);
        return true;
      }
      return false;
    } catch (e) {
      console.warn(`Failed to remove ${key} from localStorage:`, e);
      return false;
    }
  },

  // Clear all localStorage
  clear() {
    try {
      if (this.isAvailable()) {
        localStorage.clear();
        return true;
      }
      return false;
    } catch (e) {
      console.warn("Failed to clear localStorage:", e);
      return false;
    }
  },
};

export default storage;
